import { Component, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';

@Component({
  selector: 'cloud-business-reports',
  templateUrl: './business-reports.component.html',
  styleUrls: ['./business-reports.component.scss']
})
export class BusinessReportsComponent {

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  loaded = false;
  readonly icons = iconCodes;
  hasSecondTabBeenSelected = false;
  hasThirdTabBeenSelected = false;

  loadedData(e: boolean) {
    this.loaded = e;
    this.tabGroup.realignInkBar();
  }
  onTabChange(e: MatTabChangeEvent) {
      if (e?.index === 1) {
        this.hasSecondTabBeenSelected = true;
      } else if (e?.index === 2) {
        this.hasThirdTabBeenSelected = true;
      }
    }
}
